import React from "react";

const AgentInfo = ({ agent, updatedAt }) => {
  return (
    <div className="mb-6">
      <h2 className="text-xl font-semibold mb-2">Agent: {agent?.name}</h2>
      {updatedAt && (
        <div className="text-sm text-muted-foreground">
          Last updated: {new Date(updatedAt).toLocaleString()}
        </div>
      )}
    </div>
  );
};

export default AgentInfo;
